import { handleActions } from 'redux-actions';
import Immutable from 'immutable';

const initState = Immutable.fromJS({
  formBean: {
    orderId: null,
    caseId: null,
    outputFile: '', // 照片zip連結
    outputFile2: '', // 資料xls連結
    outputFileNtpc: '', // 資料xls連結-新北
    outputFileDiscard: '' // 資料建議不再使用連結
  },
  formBeanValidation: {},
  alertStyle: null,
  alertMessage: null,

  allMOrders: [],
  allMCasesByOrder: []
});

const downloadMPhotosReducer = handleActions({
  CHANGE_DOWNLOAD_MPHOTOS_VALUE: (state, { payload }) => {
    let formBean = state.get('formBean');
    return state.merge({
      formBean: formBean.set(payload.id, payload.value),
    });
  },
  BEFORE_GENERATE_DOWNLOAD_MDATA: (state, { payload }) => {
    return state.merge({
      formBean: {
        outputFile: '',
        outputFile2: '',
        outputFileNtpc: '',
        outputFileDiscard: ''
      },
      alertStyle: null,
      alertMessage: '資料處理中，請稍後。'
    });
  },
  AFTER_GENERATE_DOWNLOAD_MDATA: (state, { payload }) => {
    // open pdf file automatically
    // if (payload.data.bean.outputFile !== '') {
    //   window.open(payload.data.bean.outputFile);
    // }
    // change state
    return state.merge({
      formBean: payload.data.bean,
      formBeanValidation: payload.data.valBean,
      alertStyle: payload.data.alertStyle,
      alertMessage: payload.data.alertMessage
    });
  },
  CLEAN_DOWNLOAD_MPHOTOS_ALERT: (state, { payload }) => {
    return state.merge({
      alertStyle: null,
      alertMessage: null,
      formBean: {
        orderId: null,
        caseId: null,
        outputFile: '', // 照片zip連結
        outputFile2: '', // 資料xls連結
        outputFileNtpc: '', // 資料xls連結-新北
        outputFileDiscard: '' // 資料建議不再使用連結
      },
      formBeanValidation: {}
    })
  },
  FIND_ALL_MAINTENANCE_ORDERIDS: (state, { payload }) => {
    return state.merge({
      allMOrders: payload.data
    })
  },
  FIND_MCASES_DROPDOWNMENU: (state, { payload }) => {
    return state.merge({
      allMCasesByOrder: payload.data
    })
  }
}, initState);

export default downloadMPhotosReducer;


// WEBPACK FOOTER //
// ./src/reducers/downloadMPhotosReducer.js